export default __webpack_public_path__ + "static/media/seakrImage.11275f35.jpeg";